import { Component, input } from '@angular/core';

type PageContainerSize = 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-pan-card, [panCard]',
  templateUrl: './pan-card.component.html',
  styleUrl: './pan-card.component.scss',
  standalone: false,
})
export class PanCardComponent {
  public isPageContainer = input<boolean>(false);
  public pageContainerSize = input<PageContainerSize>('md');
  public subheader = input<string>();
  public secondarySubheader = input<string>();
  public header = input<string>();
}
